import React, {PropTypes} from 'react';

class Flags extends React.PureComponent {
  static propTypes = {
    option: PropTypes.object.isRequired,
    onSelect: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.handleMouseDown = this.handleMouseDown.bind(this);
  }

  handleMouseDown (event) {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSelect(this.props.option, event);
  }

  render() {
    return (
      <div className="icon-value-option" onMouseDown={this.handleMouseDown}>
        <span className="icon-value-label">
          {this.props.option.label}
        </span>
        <img className="lang-flag" src={require('../../images/icons/'+ this.props.option.label +'.svg')}/>
      </div>
    );
  }
}

export default Flags;



/** WEBPACK FOOTER **
 ** ./src/components/nav/Flags.js
 **/